{"light":"#f2f2f2","dark":"#0a0a0a"}